import { product_carousels } from './carousel';

export default function () {
  document.addEventListener('shopify:section:load', (e) => {
    if (e.detail.sectionId !== 'INF-ProductOverview') {
      return;
    }

    // populateCarousels();
    const carousels = document.querySelectorAll('[data-product-images-carousel]');

    if (carousels.length > 0) {
      // initProductCarousels();

      const variantSelectors = document.querySelectorAll('[data-custom-variant-selector]');
      if (variantSelectors.length > 0 && variantSelectors[0].tagName === 'SELECT') {
        variantSelectors.forEach((select) => {
          select.dispatchEvent(new Event('change'));
        });
      } else {
        const selectedVariant = document.querySelector('.ProductOption__variant--selected');
        if (selectedVariant) {
          selectedVariant.click();
        }
      }

      window.triggerResize();
    }
  });

  document.addEventListener('shopify:section:unload', (e) => {
    if (e.detail.sectionId !== 'INF-ProductOverview') {
      return;
    }

    const carousels = document.querySelectorAll('[data-product-images-carousel]');

    if (carousels.length > 0) {
      carousels.forEach((carousel) => {
        const id = carousel.getAttribute('id');
        if (product_carousels[id]) {
          product_carousels[id].destroy();
          delete product_carousels[id];
        }
      });
    }
  });
}
